/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'menu-content': {
    width: 13,
    height: 15,
    viewBox: '0 0 13 15',
    data: '<path pid="0" d="M11.74.008c.656 0 1.191.517 1.193 1.156v12.085c0 .638-.533 1.155-1.192 1.155H1.511c-.659 0-1.192-.517-1.192-1.155V1.164C.32.524.852.008 1.511.008zm0 12.33H1.51v.91h10.23v-.91zM3.051 1.163h-1.54v10.018h10.23V1.164H7.44v4.45a.58.58 0 01-.59.57h-.023a1.488 1.488 0 01-.99-.415l-.577-.56-.588.565c-.274.263-.645.41-1.031.41a.58.58 0 01-.59-.57v-4.45zm3.194 0H4.244V4.56l.735-.704a.416.416 0 01.572.002l.551.534.144.14V1.164z" _fill="#606266" fill-rule="evenodd"/>'
  }
})
